import {Component, Inject, ElementRef, ViewChild, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Asamblea} from 'src/app/intranet/model/asamblea';
import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import {functionUtil, functionHelper} from 'src/app/util/functionConst';
import {IntranetService} from 'src/app/intranet/intranet.service';
import {Representante} from 'src/app/intranet/model/representante';
import {AlertaService} from 'src/app/util/alerta.service';
import {ParametrosConst} from 'src/app/util/parametrosConst';
import {Parametro} from 'src/app/intranet/model/parametro';
import {ValidatorFunction} from 'src/app/util/validatorFunction';

@Component({
  selector: 'sura-registro-representante-dialog',
  templateUrl: './registro-representante-dialog.component.html',
  styleUrls: ['./registro-representante-dialog.component.scss']
})
export class RegistroRepresentanteComponent implements OnInit {

  @ViewChild('nombres', {static: false}) fieldNombres: ElementRef;

  public representanteForm: UntypedFormGroup;
  listTipoDocumento: Parametro[] = [];
  fnKeyDownAlphaNumeric = functionUtil.fnKeyDownAlphaNumeric;
  fnAlphaNumericMobile = functionUtil.fnAlphaNumericMobile;
  fnInputMaxLength = functionUtil.fnInputMaxLength;

  constructor(
    private _intranetService: IntranetService,
    private alertaService: AlertaService,
    public dialogRegistroRepresentante: MatDialogRef<RegistroRepresentanteComponent>,
    @Inject(MAT_DIALOG_DATA) public asamblea: Asamblea
  ) {
    this.representanteForm = new UntypedFormGroup({
      idTitular: new UntypedFormControl('', [Validators.required]),
      tipoDocumentoTitular: new UntypedFormControl('', [Validators.required]),
      numeroDocumentoTitular: new UntypedFormControl('', [
        Validators.required,
        Validators.maxLength(13),
        Validators.minLength(8), Validators.pattern('[a-zA-Z0-9]+')]),
      nombresTitular: new UntypedFormControl({value: '', disabled: true}, [Validators.required]),
      tipoDocumento: new UntypedFormControl('', [Validators.required]),
      idPersona: new UntypedFormControl(''),
      numeroDocumento: new UntypedFormControl('', [
        Validators.required, Validators.maxLength(13),
        Validators.minLength(8),
        Validators.pattern('[a-zA-Z0-9]+')]),
      nombres: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
      apellidos: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
      correo: new UntypedFormControl({value: null, disabled: true}, [Validators.required, Validators.email])
    });
    this.setValidacionDocumentoRepresentante();
  }

  ngOnInit() {
    this.cargarCombos();
  }

  closeModal(flag: boolean) {
    this.dialogRegistroRepresentante.close(flag);
  }

  guardarRepresentante() {
    if (this.representanteForm.valid) {
      const objRepresentante = this.representanteForm.getRawValue();
      const representante = new Representante();
      representante.nombres = objRepresentante.nombres;
      representante.apellidos = objRepresentante.apellidos;
      representante.correo = objRepresentante.correo;
      representante.idPersona = objRepresentante.idPersona;
      representante.idFoto = objRepresentante.idTitular;
      representante.idAsamblea = this.asamblea.id;
      representante.tipoDocumento = objRepresentante.tipoDocumento;
      representante.numeroDocumento = objRepresentante.numeroDocumento;
      representante.usuarioRegistro = 'ROOT';
      this._intranetService.guardarRepresentante(representante).then(respuesta => {
        this.alertaService.success(respuesta);
        this.closeModal(true);
      }).catch(error => {
        this.alertaService.error(error);
      });
    }
  }

  buscarTitular() {
    const representanteBsq = new Representante();
    representanteBsq.idAsamblea = this.asamblea.id;
    representanteBsq.tipoDocumento = this.representanteForm.controls.tipoDocumentoTitular.value;
    representanteBsq.numeroDocumento = this.representanteForm.controls.numeroDocumentoTitular.value;
    this.representanteForm.controls.nombresTitular.reset();
    this._intranetService.buscarTitular(representanteBsq).then((respuesta: any) => {
      this.representanteForm.controls.idTitular.setValue(respuesta.idFoto);
      this.representanteForm.controls.nombresTitular.setValue(respuesta.apellidos + ' ' + respuesta.nombres);
      this.setValidacionDocumentoRepresentante();
    }).catch(error => {
      this.alertaService.error(error);
    });
  }

  buscarPersona() {
    const tipoDocumento = this.representanteForm.controls.tipoDocumento.value;
    const numeroDocumento = this.representanteForm.controls.numeroDocumento.value;
    this.representanteForm.controls.nombres.reset();
    this.representanteForm.controls.apellidos.reset();
    this.representanteForm.controls.correo.reset();
    this._intranetService.buscarPersona(tipoDocumento, numeroDocumento).then((respuesta: any) => {
      this.representanteForm.controls.idPersona.setValue(respuesta.idPersona);
      this.representanteForm.controls.nombres.setValue(respuesta.nombres);
      this.representanteForm.controls.apellidos.setValue(respuesta.apellidos);
      this.representanteForm.controls.correo.setValue(respuesta.correo);
      this.representanteForm.controls.numeroDocumento.setValidators([Validators.required]);
    }).catch(error => {
      this.alertaService.error(error);
    });
    this.habilitarDatosPersona();
  }

  habilitarDatosPersona() {
    this.representanteForm.controls.nombres.enable();
    this.representanteForm.controls.apellidos.enable();
    this.representanteForm.controls.correo.enable();
    this.fieldNombres.nativeElement.focus();
  }

  desHabilitarBtnBsqTitular(): boolean {
    return this.representanteForm.controls.tipoDocumentoTitular.invalid || this.representanteForm.controls.numeroDocumentoTitular.invalid;
  }

  desHabilitarBtnBsqPersona(): boolean {
    return this.representanteForm.controls.tipoDocumento.invalid || this.representanteForm.controls.numeroDocumento.invalid;
  }

  cargarCombos() {
    this._intranetService.obtenerParametro(ParametrosConst.TIPO_DOCUMENTO).then(resultado => {
      if (resultado instanceof Array) {
        this.listTipoDocumento = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });
  }

  hasError(controlName: string) {
    return this.representanteForm.controls[controlName].invalid;
  }

  obtenerMensajeError(controlName: string) {
    return functionHelper.extraerErrorGroup(this.representanteForm, controlName);
  }

  changeDocIdentidadTitular(event) {
    this.setValidacionDocumentoRepresentante();
  }

  setValidacionDocumentoRepresentante() {
    const value =  this.representanteForm.controls.numeroDocumentoTitular.value;
    const cadenaEqual = value ? this.representanteForm.controls.numeroDocumentoTitular.value : '';
    this.representanteForm.controls.numeroDocumento.setValidators([
      Validators.required,
      Validators.maxLength(13),
      Validators.minLength(8),
      Validators.pattern('[a-zA-Z0-9]+'),
      ValidatorFunction.different(cadenaEqual)]);
    this.representanteForm.controls.numeroDocumento.updateValueAndValidity();
  }
}
